import { mobileQuery } from "../modules/_mobileQuery";

export const getPcSize = (value: number): string =>
  `calc(${value} / var(--pc-font-size) * 1rem)`;

export const getPcFullSize = (value: number): string =>
  `calc(${value} / var(--pc-font-size) * (var(--pc-font-size) / (1280 / 100) * 1vw))`;

export const getSpSize = (value: number): string =>
  `calc(${value} / var(--sp-font-size) * 1rem)`;

export const getSize = (value: number): string =>
  mobileQuery.matches ? getSpSize(value) : getPcSize(value);
